import { render } from "./PartitionDetail.vue?vue&type=template&id=4686bb1a&scoped=true&ts=true"
import script from "./PartitionDetail.vue?vue&type=script&lang=ts"
export * from "./PartitionDetail.vue?vue&type=script&lang=ts"

import "./PartitionDetail.vue?vue&type=style&index=0&id=4686bb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4686bb1a"]])

export default __exports__